import { motion } from 'framer-motion';
import whippetLogo from '../assets/WhippetLogo.png';
import styles from '../styles/Loader.module.css';

const Loader = () => {
  return (
    <motion.div
      className={styles.loader}
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: 'easeInOut' }}
    >
      <div className={styles.loaderInner}>
        <motion.img
          src={whippetLogo}
          alt="Whippet and Pickle"
          className={styles.logo}
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: 'easeOut' }}
        />

        <motion.p
          className={styles.wordmark}
          initial={{ opacity: 0, y: 8, letterSpacing: '0.08em' }}
          animate={{ opacity: 1, y: 0, letterSpacing: '0.02em' }}
          transition={{ duration: 1.2, delay: 0.15, ease: 'easeOut' }}
        >
          The Whippet and Pickle
        </motion.p>

        <motion.div
          className={styles.line}
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.3, ease: 'easeInOut' }}
        />
      </div>
    </motion.div>
  );
};

export default Loader;